// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1PwKp","selects":"Documents_selects__GS8OH"};